/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentKind } from './AssignmentKind';
import { AssignmentRestriction } from './AssignmentRestriction';
import { FixedGradeAvailability } from './FixedGradeAvailability';
import { TimeframeLike } from './TimeframeLike';
const AssignmentParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
    ['createdAt', parsers.moment, 'created_at'],
    ['courseId', codecNumber, 'course_id'],
    ['hasMultipleTimeframes', codecBoolean, 'has_multiple_timeframes'],
    ['isLti', codecBoolean, 'is_lti'],
    ['hasDescription', codecBoolean, 'has_description'],
    ['restrictions', AssignmentRestriction],
    ['timeframe', TimeframeLike],
    ['gradeAvailability', FixedGradeAvailability, 'grade_availability'],
    ['kind', AssignmentKind],
]));
export class Assignment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentParser.decode(input).map(res => new Assignment(res));
    }
    static unsafeDecode(input) {
        return Assignment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentParser.encode(data);
    }
    static schema() {
        return AssignmentParser.schema();
    }
}
